import { getFeature, isFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_MOBILE_BROWSER } from 'reactApp/appHelpers/configHelpers';
import { registerExperiment } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';

const DISCOUNT_IN_OUTFLOW_DEFAULT_SAVE_PERIOD_SEGMENTS = [3, 5, 10];
export const DISCOUNT_IN_OUTFLOW_SAVE_SHOW_TIMEOUT = 2000;

type DiscountInOutflowAB = 'a' | 'b' | 'c' | false;

const discountInOutflowABDesktop: DiscountInOutflowAB = getFeature('discount-in-outflow-ab');
const _discountInOutflowValueFeature: number | undefined = getFeature('discount-in-outflow-value') || undefined;
const discountInOutflowValueFeature =
    typeof _discountInOutflowValueFeature === 'number' && _discountInOutflowValueFeature > 0 && _discountInOutflowValueFeature < 100
        ? _discountInOutflowValueFeature
        : undefined;

function getDicountInOutflowValue() {
    if (discountInOutflowValueFeature) {
        return discountInOutflowValueFeature;
    }
    if (discountInOutflowABDesktop === 'b') {
        return 50;
    }
    if (discountInOutflowABDesktop === 'c') {
        return 30;
    }
    return;
}

export const discountInOutflowValue = getDicountInOutflowValue();

export const isDiscountInOutlowEnabled =
    Boolean(discountInOutflowValueFeature) || discountInOutflowABDesktop === 'b' || discountInOutflowABDesktop === 'c';

export function isDiscountOutflowOldProduct(productId?: string) {
    const is30 = productId?.endsWith('_ab_30');
    const is50 = productId?.endsWith('_ab_50');
    return is30 || is50;
}

const isSaveDiscountInOutlowEnabledValue: boolean = isFeature('discount-in-outflow-save') || false;
export const isSaveDiscountInOutlowEnabled: boolean = !IS_MOBILE_BROWSER && isDiscountInOutlowEnabled && isSaveDiscountInOutlowEnabledValue;
export const discountInOutflowSaveSegments: number[] =
    getFeature('discount-in-outflow-save-segments') || DISCOUNT_IN_OUTFLOW_DEFAULT_SAVE_PERIOD_SEGMENTS;

export const discountInOutlowDebug: boolean = isFeature('discount-in-outflow-debug') || false;

if (isDiscountInOutlowEnabled) {
    registerExperiment(
        'discount-outflow',
        discountInOutflowABDesktop,
        [
            AnalyticEventNames.MY_TARIFF_CANCEL_SALE_SHOW,
            AnalyticEventNames.MY_TARIFF_CANCEL_SALE_GET,
            AnalyticEventNames.MY_TARIFF_CANCEL_SALE_REJECT,
            AnalyticEventNames.MY_TARIFF_CANCEL_SALE_CLOSE,
        ],
        {
            mapEventNames: {
                MY_TARIFF_CANCEL_SALE_SHOW: 'show',
                MY_TARIFF_CANCEL_SALE_GET: 'get',
                MY_TARIFF_CANCEL_SALE_REJECT: 'reject',
                MY_TARIFF_CANCEL_SALE_CLOSE: 'close',
            },
        }
    );
}

if (isSaveDiscountInOutlowEnabled) {
    registerExperiment(
        'discount-save',
        'b',
        [
            AnalyticEventNames.DISCOUNT_LS_SAVE,
            AnalyticEventNames.DISCOUNT_LS_CLEAR,

            AnalyticEventNames.DISCOUNT_MODAL_SHOW,
            AnalyticEventNames.DISCOUNT_MODAL_CLICK,
            AnalyticEventNames.DISCOUNT_MODAL_CANCEL,
            AnalyticEventNames.DISCOUNT_MODAL_ENABLE,

            AnalyticEventNames.DISCOUNT_TIMER_SHOW,
            AnalyticEventNames.DISCOUNT_TIMER_CLICK,
            AnalyticEventNames.DISCOUNT_TIMER_CANCEL,

            AnalyticEventNames.CANCEL_SUB_SUCCESS,
        ],
        {
            sendXrayArgs: {
                DISCOUNT_MODAL_SHOW: ({ type }) => ({ eventName: `show-${type}` }),
                DISCOUNT_MODAL_CLICK: ({ type }) => ({ eventName: `click-${type}` }),
                DISCOUNT_MODAL_CANCEL: ({ type }) => ({ eventName: `cancel-${type}` }),
                DISCOUNT_MODAL_ENABLE: ({ type }) => ({ eventName: `enable-${type}` }),
            },

            mapEventNames: {
                DISCOUNT_LS_SAVE: 'ls-save',
                DISCOUNT_LS_CLEAR: 'ls-clear',
                DISCOUNT_TIMER_SHOW: 'show-timer',
                DISCOUNT_TIMER_CLICK: 'click-timer',
                DISCOUNT_TIMER_CANCEL: 'cancel-timer',
                CANCEL_SUB_SUCCESS: 'autorenew-cancel',
            },
        }
    );
}
